module.exports = __webpack_public_path__ + "img/17a003-11.ebfdab8a.png";